// extracted by mini-css-extract-plugin
export var boxItems = "_7o-1";
export var boxItemsLg = "_7o-2";
export var button = "_7o-7";
export var buttonLg = "_7o-8";
export var filterGroupBox = "_7o-0";
export var icon = "_7o-3";
export var iconSecondary = "_7o-6";
export var iconWrapper = "_7o-4";
export var iconWrapperLg = "_7o-5";